import React, {useEffect, useState, useCallback} from "react";
import {createUseStyles, useTheme} from "react-jss";
import TabNav from "@artibulles-cis/react/TabNav";
import {useHistory, useParams} from "react-router-dom";
import Button from "@artibulles-cis/react/Button";
import APICallExternal from "@artibulles-cis/react/utils/APICallExternal";
import LocalCircularLoader from "@artibulles-cis/react/LocalCircularLoader";

import CardOverview from "./CardOverview/CardOverview";
import CardEdit from "./CardEdit/CardEdit";
import CreditCardTransactions from "./CreditCardTransactions/CreditCardTransactions";
import CreditCardSettlement from "./CreditCardSettlerment/CreditCardSettlement";

//eslint-disable-next-line
const styles = createUseStyles((theme) => ({
    NoAccount_Wrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        jusitfyContent: "center",
        boxSizing: "border-box",
        marginTop: "15px",
    },
    TabTitle_WithIcon: {
        display: "flex",
        alignItems: "center",
    },
    TabTitle_WithIcon_Title: {
        marginLeft: "5px",
    },
}));

const Component = (props) => {
    //eslint-disable-next-line
    const theme = useTheme();
    //eslint-disable-next-line
    const classes = styles({...props, theme});

    /***************** CONST ******************/
    const LocationParams = useParams();
    const DevMode = process.env.NODE_ENV === "development" ? true : false;
    const ProdURL = DevMode ? "" : "https://artibulles-BMS.artibulles.com";
    const History = useHistory();
    /***************** CONST ******************/

    /***************** STATE ******************/
    const [ApiRes, setApiRes] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [CompReady, setCompReady] = useState(false);
    const [Id, SetId] = useState(LocationParams.id);
    const [NoBankAccount, setNoBankAccount] = useState(false);
    /***************** STATE ******************/

    /***************** CALLBACK ******************/
    const EndofAPI = useCallback(() => {
        //Making sure the Loading is done and the Results are ready
        if (!Loading && ApiRes) {
            if (ApiRes.error) {
                if (ApiRes.errorStatus === 404) {
                }
            } else {
                
                if (ApiRes.data && ApiRes.data.data) {
                    let Data = ApiRes.data.data;
                    History.push(`/financials/companyaccount/creditcards/card/${Data._id}/overview`);
                    setCompReady(true);
                } else {
                    if (ApiRes.data && ApiRes.data.message) {
                        if (ApiRes.data.message === "No bank account") {
                            //Prevent the user from creating any cards
                            setNoBankAccount(true);
                            setCompReady(true);
                        } else {
                            //No card for this user
                            setCompReady(true);
                        }
                    } else {
                        //No card for this user
                        setCompReady(true);
                    }
                }
            }
        }
    }, [ApiRes, Loading]);
    /***************** CALLBACK ******************/

    /***************** EFFECTS ******************/

    //If there is no Id in the route -> Contact the Api to get the Id
    useEffect(() => {
        if (Id === "default") {
            const ApiCall = {url: `${ProdURL}/api/companyaccount/creditcards/card/default`, type: "get"};
            setLoading(true);
            setCompReady(false);
            async function APIInternal() {
                const res = await APICallExternal(ApiCall);
                setApiRes(res);
                setLoading(false);
            }
            APIInternal();
        }
    }, [ProdURL, Id]);

    //PREVENT API CALLS LOOPS
    useEffect(() => {
        if (!Loading && ApiRes) {
            EndofAPI();
        }
    }, [Loading, ApiRes]);

    useEffect(() => {
        if (LocationParams.id) {
            if (LocationParams.id !== "default") {
                SetId(LocationParams.id);
                setCompReady(true);
                setLoading(false);
            }
        }
    }, [LocationParams]);

    /***************** EFFECTS ******************/

    /***************** FUNCTIONS ******************/
    const HandleAddCreditCard = () => {
        History.push("/financials/companyaccount/creditcards/card/new/view");
    };
    const HandleAddBankAccount = () => {
        History.push("/financials/companyaccount/bankaccounts/account/new/view");
    };

    /***************** FUNCTIONS ******************/

    /***************** RENDER ******************/

    var FinalComponent;
    if (Loading === true || CompReady === false) {
        FinalComponent = (
            <div>
                <LocalCircularLoader WithModalCard={true} Loading={Loading} FullSize={true} />
            </div>
        );
    } else {
        if (Id === "default") {
            if (NoBankAccount === true) {
                FinalComponent = (
                    <div className={classes.NoAccount_Wrapper}>
                        <div>You don't have any bank account</div>
                        <div>You first need to create one before you can add a a credit card</div>

                        <Button Width="250px" onClick={HandleAddBankAccount}>
                            Create Bank Account ?
                        </Button>
                    </div>
                );
            } else {
                FinalComponent = (
                    <div className={classes.NoAccount_Wrapper}>
                        <div>You don't have any default credit card selected</div>
                        <div>You can set your default credit card by editing it from the credit cards list</div>
                        <div>Or you can Add a credit card </div>

                        <Button Width="250px" onClick={HandleAddCreditCard}>
                            Add Credit Card ?
                        </Button>
                    </div>
                );
            }
        } else {
            FinalComponent = (
                <TabNav
                    MainSlug={`/financials/companyaccount/creditcards/card/:id`}
                    DefaultTab={`/financials/companyaccount/creditcards/card/${Id}/overview`}
                    ActiveIndicator={{
                        WithIndicator: true,
                        Position: "Bottom",
                    }}
                    TabMenuContent={[
                        {
                            TabMenu: (
                                <div className={classes.TabMenuDiv}>
                                    <div className={classes.TabTitle}>Overview</div>
                                </div>
                            ),
                            Slug: `/financials/companyaccount/creditcards/card/${Id}/overview`,
                            TabContent: <CardOverview />,
                        },
                        {
                            TabMenu: (
                                <div className={classes.TabMenuDiv}>
                                    <div className={classes.TabTitle}>Credit Card Details</div>
                                </div>
                            ),
                            Slug: `/financials/companyaccount/creditcards/card/${Id}/view`,
                            TabContent: <CardEdit Id={Id ? Id : null} />,
                        },
						{
                            TabMenu: (
                                <div className={classes.TabMenuDiv}>
                                    <div className={classes.TabTitle}>Credit Card Transactions</div>
                                </div>
                            ),
                            Slug: `/financials/companyaccount/creditcards/card/${Id}/transaction`,
                            TabContent: <CreditCardTransactions Id={Id ? Id : null} />,
                        },
						{
                            TabMenu: (
                                <div className={classes.TabMenuDiv}>
                                    <div className={classes.TabTitle}>Credit Card Settlements</div>
                                </div>
                            ),
                            Slug: `/financials/companyaccount/creditcards/card/${Id}/settlement`,
                            TabContent: <CreditCardSettlement Id={Id ? Id : null} />,
                        },
                    ]}
                />
            );
        }
    }

    return <React.Fragment>{FinalComponent}</React.Fragment>;

    /***************** RENDER ******************/
};

export default Component;
